<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <NoticePlaceholder v-if="loadError"
                           :style="'height: 30vh;min-height:200px'"
                           :largeText="true"
                           icon="pi pi-exclamation-triangle"
                           :title="$t('notAvailableTitle')"
                           :text="$t('itemCannotBeDisplayedMsg')"/>
        <Toolbar class="p-mb-4 p-p-2" v-else-if="!isLoading" :class="{'datatable-is-loading':dataIsSending}">
          <!--          <template v-slot:left>-->
          <template #start>
            <div class="p-p-2">
              <div style="font-size: 1.4em; color: inherit">{{ $t('Order') }}: {{ orderData?.number ?? '' }}</div>
            </div>
          </template>
          <!--          <template v-slot:right v-if="orderData">-->
          <!--          :disabled="(disableEditButton && isItemUpdated(item.id)) || dataTableIsLoading"-->
          <template #end v-if="orderData">
            <span class="p-d-inline-flex"
                  v-tooltip.bottom="billingActionTooltipOptions()">
              <Button :disabled="disableEditButton || dataIsSending || billingDataEditingLocked"
                      class="p-button-raised p-button-success"
                      :loading="dataIsSending"
                      icon="pi pi-comments"
                      :label="$t('editStaffCommentLabel')"
                      @click="editStaffComment"/>
            </span>
          </template>
        </Toolbar>
        <Spinner v-if="isLoading"/>
        <!--        <div v-else-if="!isLoading">{{ orderData }}</div>-->

        <div v-else-if="!isLoading && orderData" class="p-grid" :class="{'datatable-is-loading':dataIsSending}">
          <div class="p-col-12 p-sm-12 p-md-6 p-lg-4">
            <fieldset class="p-fieldset">
              <legend class="p-fieldset-legend p-p-2">{{$t('Files')}} <span v-if="orderFilesLength"> ({{orderFilesLength}}/10) </span></legend>
              <NoticePlaceholder v-if="!orderFilesLength"
                                 :style="'padding: 0'"
                                 icon="ti-files"
                                 :text="$t('noFilesYet')"/>

              <FilesList v-else
                         :loading="dataIsSending"
                         :files="orderData?.files"
                         :itemId="orderData?.id"
                         :canDelete="!billingDataEditingLocked"
                         entity="order"
                         @update-item="updateItem"/>
              <hr class="p-mt-2 p-mb-2" v-show="orderFilesLength">

              <div class="p-d-flex p-ai-center p-flex-wrap">
                <div class="p-mt-2 p-mr-2"
                     v-tooltip.top="billingActionTooltipOptions()">
                  <Button @click="addFiles"
                          :loading="dataIsSending"
                          :disabled="disableEditButton || dataIsSending || orderFilesLength >= 10 || billingDataEditingLocked"
                          class="p-button-text"
                          icon="pi pi-plus"
                          :label="$t('Add')"/>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <!--        <div v-else class="empty-page">{{ $t('No data available') }}</div>-->
      </div>
      <!--      Second part-->
      <div v-if="!isLoading && orderData" class="card p-mt-4" :class="{'datatable-is-loading':dataIsSending}">
        <div class="p-grid p-mb-3">
          <div class="p-col-12 p-sm-12 p-md-6 p-lg-4 p-fluid info-card">
            <Panel :header="$t('orderDetailsPanelTitle')">
              <div class="panel-inner">
                <div class="panel-info-block-grid">
                  <div class="panel-info-block-label p-p-1">{{ $t('Name') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.name">{{ orderData.name }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('Time') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.time && +orderData.time">{{ formatHoursAndMinutes(orderData.time) }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('Status') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <div class="p-d-flex p-ai-center">
                      <OrderStateButton :ref="'orderStateBtn-' + orderData.id"
                                        :item="orderData"
                                        :disabled="dataIsSending"
                                        :canChangeState="false"/>
                    </div>
                  </div>

                  <template v-if="orderData.state === 12">
                    <div class="panel-info-block-label p-p-1">{{ $t('cancellationReasonLabel') }}:</div>
                    <div class="panel-info-block-value p-p-1">
                      <span v-if="orderData.cancellation_reason" class="word-break">
                        {{ orderData.cancellation_reason }}
                      </span>
                      <i v-else class="ti-minus"/>

                    </div>
                  </template>

                  <div class="panel-info-block-label p-p-1">{{ $t('Start') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.start">{{ formatDate(orderData.start) }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('End') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.end && orderData.end !== orderData.start">{{ formatDate(orderData.end) }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('workstation') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.area?.name">{{ orderData.area.name }} <span v-if="orderData.area.description"> ({{orderData.area.description}})</span></span>
                    <i v-else class="ti-minus"/>
                  </div>
                </div>
              </div>
            </Panel>
          </div>

          <div class="p-col-12 p-sm-12 p-md-6 p-lg-4 p-fluid info-card">
            <Panel :header="$store.getters.isForkliftTenant ? $t('equipmentDetailsPanelTitle') : $t('vehicleDetailsPanelTitle')">
              <NoticePlaceholder v-if="!orderData.car"
                                 :style="'padding: 56px'"
                                 :icon="$store.getters.isForkliftTenant ? 'ti-truck' : 'ti-car'"
                                 :text="$store.getters.isForkliftTenant ? $t('noEquipmentSelectedMsg') : $t('noVehicleSelectedMsg')"/>

              <div class="panel-inner" v-else>
                <div class="panel-info-block-grid">
                  <div class="panel-info-block-label p-p-1">{{ $t('Make') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="carMakeName(orderData.car)">{{ carMakeName(orderData.car) }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('Model') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="carModelName(orderData.car)">{{ carModelName(orderData.car) }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">
                    {{ $store.getters.isForkliftTenant ? $t('Serial Number') : $t('Plate number') }}:
                  </div>

                  <div class="panel-info-block-value p-p-1">
                    <div v-if="carIdentifier(orderData.car)" class="p-d-flex p-ai-center">
                      <span>
                        {{ carIdentifier(orderData.car) }}
                      </span>

                      <CarDataLink v-if="orderData.car.plate_number"
                                   class="p-ml-2"
                                   :plateNumber="orderData.car.plate_number"
                                   :showOnlyIcon="true"/>
                    </div>

                    <i v-else class="ti-minus"/>
                  </div>


                  <div class="panel-info-block-label p-p-1">
                    {{ $store.getters.isForkliftTenant ? $t('Asset Code') : $t('VIN number') }}:
                  </div>
                  <div class="panel-info-block-value p-p-1">
                    <template v-if="$store.getters.isForkliftTenant && orderData.car.asset_code">
                      {{ orderData.car.asset_code }}
                    </template>
                    <template v-else-if="orderData.car.vin">
                      {{ orderData.car.vin }}
                    </template>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('Year') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.car.year">{{ orderData.car.year }}</span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('Engine code') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.car.engine_code">{{ orderData.car.engine_code }}</span>
                    <i v-else class="ti-minus"/>
                  </div>
                </div>
              </div>
            </Panel>
          </div>

          <div class="p-col-12 p-sm-12 p-md-6 p-lg-4 p-fluid info-card">
            <Panel :header="$t('additionalDetailsPanelTitle')">
              <div class="panel-inner">
                <div class="panel-info-block-grid">
                  <div class="panel-info-block-label p-p-1">{{ $t('Created') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.created_at"
                          :class="{ 'created-by-customer': orderData.source === 2 }">
                      {{ formatBy(orderData.created_at, orderData.creator) }}
                    </span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('archivedLabel') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <template v-if="orderData.archived_at">
                      {{ formatBy(orderData.archived_at, orderData.archivedBy) }}
                    </template>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('serviceAdvisorLabel') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <span v-if="orderData.responsible">
                      {{ orderData.responsible.first_name || '' }} {{ orderData.responsible.last_name || '' }}
                    </span>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $t('techniciansLabel') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <template v-if="orderData.masters?.length">
                    <span v-for="(master, index) of orderData.masters" :key="master.id">
                      <span>{{ master.user.first_name || '' }} {{ master.user.last_name || '' }}</span>
                      <span v-if="orderData.masters.length > 1 && index !== orderData.masters.length - 1">,&nbsp;</span>
                    </span>
                    </template>
                    <i v-else class="ti-minus"/>
                  </div>

                  <div class="panel-info-block-label p-p-1">{{ $store.getters.isForkliftTenant ? $t('engineHours') : $t('Mileage') }}:</div>
                  <div class="panel-info-block-value p-p-1">
                    <template v-if="orderData.mileage">
                      {{ formatMileage(orderData.mileage) }}
                      <span v-if="!$store.getters.isForkliftTenant">{{ $t(settings.measurements.mileage) }}</span>
                    </template>
                    <i v-else class="ti-minus"/>
                  </div>
                </div>
              </div>
            </Panel>
          </div>

        </div>
        <PositionsTable v-if="orderData"
                        :item="orderData"
                        :showDeletedPositions="showDeletedPositions"
                        :showFinancialData="false"
                        :showServiceWorkTimeInsteadOfQty="true"
                        :dataIsSending="dataIsSending"
                        :isSpoilerTable="false"
                        @update-items="updateItems"/>
      </div>

      <OrderFilesModal :visible="filesModal"
                       @close="closeOrderFilesModal"
                       :orderId="orderData?.id"
                       :orderFilesLength="orderFilesLength"
                       @update-item="updateItem"/>


      <OrderStaffCommentModal :visible="orderStaffCommentModal"
                              @update-staff-comment="updateOrderStaffComment"
                              @close="closeOrderStaffCommentModal"
                              :item="staffCommentData"/>
    </div>
  </div>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from '@/settings.js'
import constants from '@/constants'
import OrderStateButton from '@/pages/orders/components/OrderStateButton'
import formatMixins from '@/mixins/formatMixins'
import PositionsTable from '@/components/PositionsTable'
import httpMixins from "@/mixins/httpMixins";
import datatableMixins from "@/mixins/datatableMixins";
import OrderFilesModal from "@/pages/orders/components/OrderFilesModal";
import webSocketMixins from "@/mixins/webSocketMixins";
import OrderStaffCommentModal from "@/pages/orders/components/OrderStaffCommentModal";
import NoticePlaceholder from "@/components/NoticePlaceholder.vue";
import FilesList from "@/components/FilesList.vue";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import CarDataLink from "@/pages/vehicles/components/CarDataLink.vue";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  components: {
    CarDataLink,
    FilesList,
    NoticePlaceholder,
    OrderStateButton,
    PositionsTable,
    OrderFilesModal,
    OrderStaffCommentModal
  },
  mixins: [ formatMixins, httpMixins, datatableMixins, webSocketMixins, showErrorsMixins, billingRestrictionsMixin ],
  data() {
    return {
      loadError: false,
      dataIsSending: false,
      staffCommentData: {},
      fileToDelete: {},
      confirmDeleteFileModal: false,
      filesModal: false,
      orderStaffCommentModal: false,
      disableEditButton: false,
      orderMasters: [],
      servicePositions: null,
      orderData: null,
      isLoading: true,
      deletedPositions: false,
      showDeletedPositions: false,
      settings,
      constants
    }
  },
  watch: {
    '$store.state.firstLayerIsOpened'() {
      if (!this.$store.state.firstLayerIsOpened) {
        if (this.filesModal) {
          this.closeOrderFilesModal()
        }
        if (this.confirmDeleteFileModal) {
          this.closeConfirmDeleteFileModal()
        }
        if (this.orderStaffCommentModal) {
          this.closeOrderStaffCommentModal()
        }
      }
    },
    '$store.state.updatedOrderId'(orderId) {
      if (!orderId) return

      this.updateItem(orderId)

      setTimeout(() => {
        this.$store.commit('changeUpdatedOrderId', null)
      }, 100)
    },
  },
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    // this.getOrderData()
    this.getPageData()
  },
  methods: {
    getAttachmentName(att) {
      return (att?.source_name || att?.file_path || '').toLowerCase();
    },
    isImage(att) {
      const mime = att.mime_type || '';
      const name = this.getAttachmentName(att);

      if (mime.startsWith('image/')) return true;

      const exts = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
      return exts.some(ext => name.endsWith(ext));
    },
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      this.getOrderData()
    },
    updateItem(id, sendSocket = false) {
      const orderDataId = this.orderData?.id
      // console.log('id: ' + id, 'orderDataId: ' + orderDataId)
      if (!orderDataId || id !== orderDataId) return

      this.disableEditButton = true
      if (this.$route.params.uid) {
        this.getOrderData(false)

        if (sendSocket) {
          this.sendUpdateOrderWebSocket(orderDataId)
        }
      }
    },
    editStaffComment() {
      if (this.billingActionIsRestricted()) return

      if (!this.orderData) return
      this.staffCommentData = {
        orderId: this.orderData.id,
        comment: this.orderData.staff_comment,
      }
      this.orderStaffCommentModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    updateOrderStaffComment(obj) {
      if (!obj) return false
      this.orderData.staff_comment = obj.staff_comment

      // if (!this.orderData.comments_history) this.orderData.comments_history = []
      // this.orderData.comments_history.push({
      //   type: 2,
      //   comment: obj.staff_comment,
      //   created_at: Date.now() / 1000,
      //   creator: {
      //     first_name: this.$store.state.user?.first_name,
      //     last_name: this.$store.state.user?.last_name
      //   },
      // })
      this.updateItem(this.orderData?.id, true)
    },
    closeOrderStaffCommentModal() {
      this.staffCommentData = {}
      this.orderStaffCommentModal = false
      this.$store.commit('toggleFirstLayer', false)
    },
    closeConfirmDeleteFileModal() {
      this.confirmDeleteFileModal = false
      this.$store.commit('toggleFirstLayer', false)
      this.fileToDelete = {}
    },
    addFiles() {
      if (this.billingActionIsRestricted()) return

      this.filesModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    closeOrderFilesModal() {
      this.filesModal = false
      this.$store.commit('toggleFirstLayer', false)
    },
    async getOrderData(showSpinner = true) {
      if (!this.$route.params.uid) return
      if (!this.userCanGetData || this.fetchInFlight) return

      this.loadError = false

      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.disableEditButton = true
      this.isLoading = showSpinner
      this.dataIsSending = true
      this.disableEditButton = true
      const ctrl = this.setController?.('masterOrderData')
      try {
        // const { data, status } = await httpClient.post('order/get-by-uid?expand=responsible,creator,archivedBy,positions,masters.employee,car,area,state_history,comments_history,recommendation_history,files.createdBy', { uid: this.$route.params.uid })

        const { status, data } = await httpClient({
          // const { data } = await httpClient({
          url: 'order/get-by-uid',
          method: 'post',
          params: {
            // page: this.pagination.currentPage,
            // 'per-page': this.pagination.perPage,
            // sort: this.sort.direction + this.sort.column,
            // search: this.processedSearchValue ?? null,
            // expand: 'responsible,creator,archivedBy,positions,masters.employee,car,area,state_history,comments_history,recommendation_history,files.createdBy',
            expand: 'responsible,creator,archivedBy,positions,positions.service,masters.employee,car,area,change_history_counts,files.createdBy',
          },
          data: { uid: this.$route.params.uid },
          signal: ctrl?.signal
        })
        if (status === 200 && data?.success && data.item) {
          const order = data.item
          this.orderData = order
          this.orderData.selectedCustomer = order.customer ? order.customer : null
          this.orderData.selectedCar = order.car ? order.car : null
        } else {
          this.orderData = null
          this.order = {}
          this.loadError = true
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        // this.$store.commit('changeUpdatedOrderId', null)
        this.isLoading = false
        this.dataIsSending = false
        this.disableEditButton = false
        if (this._abortors?.masterOrderData === ctrl) {
          this._abortors.masterOrderData = null
        }
      }
    },
  },
  computed: {
    orderFilesLength() {
      if (!this.orderData?.files?.length) return 0
      return this.orderData.files.length
    },
  }
}
</script>
<style lang="scss" scoped>
.order-file-btn {
  width: auto;
  padding: 4px 6px;
  display: inline-flex;
  align-items: center;
  //justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
}

.order-file-icon {
  font-size: 14px;
}
</style>